import { riverIceChurchillLegend } from '../config/legends'
import { riverIceLegend } from '../config/legends'

const service = {
  name: 'RiverIceChurchill',
  label: 'River Ice Churchill',
  permissionId: 'riverice',
  iconComponent: 'RiverIce',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  data: [
    {
      id: 'RiverIceBreakup',
      url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ARiverIceAreaSummary&propertyName=value,date,area,ratio,timestamp,type,gridcode`,
      datetimeId: 'RiverIceChurchill',
      type: 'extent',
      active: 'active'
    }
  ],
  layers: [
    // {
    //   name: 'RiverIce',
    //   label: 'Ice classification',
    //   opacity: 'fill-opacity',
    //   datetimeId: 'RiverIce',
    //   open: true,
    //   legend: {
    //     type: 'categorical',
    //     data: riverIceChurchillLegend
    //   },
    // },
    {
      name: 'RiverIceChurchill',
      label: 'Ice classification',
      opacity: 'fill-opacity',
      datetimeId: 'RiverIceChurchill',
      open: true,
      datetimeTransform: 'riverIceUtcDatetime',
      legend: {
        type: 'categorical',
        data: riverIceChurchillLegend
        // data: riverIceLegend
      },
    },
    {
      name: 'ChurchillMarkers',
      opacity: 'fill-opacity',
      hidden: true
    },
    // {
    //   name: 'Sentinel1RiverIceChurchill',
    //   label: 'Sentinel 1',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'RiverIceChurchill',
    // }
  ],
  locations: [
    {
      name: 'Churchill River',
      extent: [[54.65, -114.2], [57.23, -111.08]],
      latitude: 53.35,
      longitude: -60.5059,
      zoom: [10],
      maxBounds: [[-80, 51], [-55, 68]]
    }
  ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/RiverIceChurchill.js